
import React, { useEffect, useState } from 'react';
import Card from '../components/Card';
import Card1 from '../components/Card1';
import Card2 from '../components/Card2';
import Card3 from '../components/Card3';
import Card4 from '../components/Card4';
import Card5 from '../components/Card5';
import Card6 from '../components/Card6';
import Card7 from '../components/Card7';
import Card8 from '../components/Card8';
import Card9 from '../components/Card9';
import Card10 from '../components/Card10';



// ── Séparateur de section ─────────────────────────────────────────
const SectionLabel = ({ label, top, left = '220px', width = '760px' }) => (
  <div style={{
    position: 'absolute', top, left, width,
    display: 'flex', alignItems: 'center', gap: '14px',
  }}>
    <div style={{ flex: 1, height: '1px', background: '#e9ecef' }} />
    <span style={{
      fontSize: '11px', fontWeight: 700, letterSpacing: '2px',
      textTransform: 'uppercase', color: '#6c757d',
      whiteSpace: 'nowrap',
    }}>
      {label}
    </span>
    <div style={{ flex: 1, height: '1px', background: '#e9ecef' }} />
  </div>
);

const Home = () => {
  return (
    <div style={{
      fontFamily: "'Segoe UI', sans-serif",
      position: 'relative',
      minHeight: '800px',
      padding: '0 0 40px 0',
    }}>

      {/* ════════════════════════════════
          SECTION — FINANCES
      ════════════════════════════════ */}
      <SectionLabel label="Finances" top="90px" />

      <div style={{ position: 'absolute', top: '130px', left: '220px' }}><Card /></div>
      <div style={{ position: 'absolute', top: '130px', left: '480px' }}><Card1 /></div>
      <div style={{ position: 'absolute', top: '130px', left: '730px' }}><Card2 /></div>

      {/* ════════════════════════════════
          SECTION — VENTES
      ════════════════════════════════ */}
      <SectionLabel label="Ventes" top="330px" />

      <div style={{ position: 'absolute', top: '370px', left: '220px' }}><Card3 /></div>
      <div style={{ position: 'absolute', top: '370px', left: '480px' }}><Card4 /></div>
      <div style={{ position: 'absolute', top: '370px', left: '730px' }}><Card5 /></div>
      <div style={{ position: 'absolute', top: '370px', left: '980px' }}><Card6 /></div>

      {/* ════════════════════════════════
          SECTION — STOCKS
      ════════════════════════════════ */}
      <SectionLabel label="Stocks" top="560px" />

      <div style={{ position: 'absolute', top: '610px', left: '220px' }}><Card7 /></div>
      <div style={{ position: 'absolute', top: '610px', left: '480px' }}><Card8 /></div>
      <div style={{ position: 'absolute', top: '610px', left: '720px' }}><Card9 /></div>

    </div>
  );
};

export default Home;